const NS = 'CourseBarBlock';
const CLS = 'courseBarBlock';

export class CourseBarBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.$infoButton = this.$element.find(`.${CLS}-overview-information-item--info`);

		this.$overviewToggle = this.$element.find(`.${CLS}-overview-toggler`);
		this.$overviewDescription = this.$element.find(`.${CLS}-overview-description`);
		this.$overviewActionsTopicsButton = this.$element.find(`.${CLS}-overview-actions-btn--topics`);

		this.$specs = this.$element.find(`.${CLS}-specs`);

		this.$infoButton.on('click', () => {
			this.$overviewDescription.toggle();
		});

		this.$overviewToggle.on('click', () => {
			if(!this.$element.hasClass(`${CLS}--compact`)) {
				this.$element.addClass(`${CLS}--compact`);
			}
			else {
				this.$element.removeClass(`${CLS}--compact`);
			}
		});

		this.$overviewActionsTopicsButton.on('click', () => {
			if(!this.$specs.hasClass(`${CLS}-specs--show`)) {
				this.$specs.addClass(`${CLS}-specs--show`);
			}
			else {
				this.$specs.removeClass(`${CLS}-specs--show`);
			}
		});
	}
}
